import {
  Button,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  FormControl,
  FormLabel,
  Input,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  useDisclosure
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import IFilter from '../../../interfaces/AceleraMagenta/index/IFilter'
import AceleraMagentaService from '../../../services/AceleraMagenta/AceleraMagentaService'
import AceleraMagentaViewPage from './AceleraMagentaViewPage'

interface IAcelera {
  id: number
  employee_id: number
  created_by: string
  step: number
  done: boolean
  scoreMaturityDirection: number
  scoreMaturityOrientation: number
  scoreMaturitySupport: number
  scoreMaturityDelegation: number
  scoreEffectiveDelegation: number
  created_at: string
  updated_at: string
  link_pdf: string
  employee: {
    id: number
    name: string
    email: string
    birthdate: string
    nickname: string
    position: string
    created_at: string
    updated_at: string
  }
}

export default function AceleraMagentaPage() {
  const modalState = useDisclosure()
  const aceleraMagentaService = new AceleraMagentaService()
  const [aceleraMagentaId, setAceleraMagentaId] = useState<number>()
  const [aceleras, setAceleras] = useState<IAcelera[]>([])
  const [filter, setFilter] = useState<IFilter>({
    date: {
      start: '',
      end: ''
    },
    manager: '',
    name: '',
    sector: ''
  })

  const filterSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    refreshTable()
  }

  const refreshTable = () => {
    aceleraMagentaService.list(filter).then((response) => {
      setAceleras(response.data)
    })
  }

  const confirmDelete = (id: number) => {
    if (window.confirm('Deseja realmente excluir este registro?')) {
      aceleraMagentaService.delete(id).then(() => {
        refreshTable()
      })
    }
  }

  useEffect(() => {
    refreshTable()
  }, [])

  return (
    <>
      <Link to="/acelera-magenta/new">
        <Button
          position="fixed"
          bottom="5"
          right="5"
          size="lg"
          colorScheme="magenta"
          borderRadius="full"
          boxShadow="lg"
          width={16}
          height={16}
          _hover={{ boxShadow: 'xl' }}
          _active={{ boxShadow: 'md' }}
        >
          <i className="lni lni-plus"></i>
        </Button>
      </Link>

      <form onSubmit={filterSubmit}>
        <Flex alignItems="center">
          <FormControl mr={2}>
            <FormLabel>Nome:</FormLabel>
            <Input
              type="text"
              placeholder="Digite o nome"
              value={filter.name}
              onChange={(e) => setFilter({ ...filter, name: e.target.value })}
            />
          </FormControl>

          <FormControl mr={2}>
            <FormLabel>Setor:</FormLabel>
            <Input
              type="text"
              placeholder="Digite o setor"
              value={filter.sector}
              onChange={(e) => setFilter({ ...filter, sector: e.target.value })}
            />
          </FormControl>

          <FormControl mr={2}>
            <FormLabel>Gestor:</FormLabel>
            <Input
              type="text"
              placeholder="Digite o nome do gestor"
              value={filter.manager}
              onChange={(e) => setFilter({ ...filter, manager: e.target.value })}
            />
          </FormControl>

          <FormControl mr={2} w="100%">
            <FormLabel>Data:</FormLabel>
            <Flex>
              <Input
                type="date"
                mr={2}
                value={filter.date.start}
                onChange={(e) => setFilter({ ...filter, date: { ...filter.date, start: e.target.value } })}
                max={filter.date.end}
              />
              <Input
                type="date"
                value={filter.date.end}
                onChange={(e) => setFilter({ ...filter, date: { ...filter.date, end: e.target.value } })}
                min={filter.date.start}
              />
            </Flex>
          </FormControl>
        </Flex>
        <Flex alignItems="center" mt={2} mb={5} justifyContent="flex-end">
          <Button colorScheme="magenta" mt={2} type="submit">
            Filtrar
          </Button>
        </Flex>
      </form>

      <TableContainer>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>#</Th>
              <Th>Colaborador</Th>
              <Th>Realizado por</Th>
              <Th>Realizado em</Th>
              <Th>Ações</Th>
            </Tr>
          </Thead>
          <Tbody>
            {aceleras.map((acelera: IAcelera) => (
              <Tr key={acelera.id}>
                <Td>{acelera.id}</Td>
                <Td>{acelera.employee.name}</Td>
                <Td>{acelera.created_by}</Td>
                <Td>{convertDateTime(acelera.created_at)}</Td>
                <Td>
                  {!!acelera.done && (
                    <>
                      <Button
                        colorScheme="blue"
                        size="sm"
                        mx="2"
                        onClick={() => {
                          modalState.onOpen()
                          setAceleraMagentaId(acelera.id)
                        }}
                      >
                        <i className="lni lni-eye"></i>
                      </Button>
                      <a href={acelera.link_pdf} download="Acelera Magenta.pdf" target="_blank" rel="noreferrer">
                        <Button colorScheme="green" size="sm" mx="2">
                          <i className="lni lni-download"></i>
                        </Button>
                      </a>
                    </>
                  )}
                  {!acelera.done && (
                    <Link to={`/acelera-magenta/${acelera.id}`}>
                      <Button colorScheme="magenta" size="sm" mx="2">
                        <i className="lni lni-pencil"></i>
                      </Button>
                    </Link>
                  )}
                  <Button
                    colorScheme="red"
                    size="sm"
                    mx="2"
                    onClick={() => {
                      confirmDelete(acelera.id)
                    }}
                  >
                    <i className="lni lni-trash-can"></i>
                  </Button>
                </Td>
              </Tr>
            ))}
            {aceleras.length === 0 && (
              <Tr>
                <Td colSpan={5}>
                  <p className="text-center">Nenhum registro encontrado</p>
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </TableContainer>

      <Modal isOpen={modalState.isOpen} onClose={modalState.onClose} size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody paddingTop="10" paddingBottom="10">
            {aceleraMagentaId != undefined && (
              <AceleraMagentaViewPage aceleraMagentaId={aceleraMagentaId} skipLastStep={false} />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

const convertDateTime = (datetime: string) => {
  const date = new Date(datetime)
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear()
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  const seconds = date.getSeconds().toString().padStart(2, '0')

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
}
